import React from "react";
import ProfileDetails from "../../Components/profile/ProfileDetails";

const Profile = () => {
  return (
    <div>
      <ProfileDetails />
    </div>
  );
};

export default Profile;
